import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { values } from 'lodash';

import { fetchRegions, selectRegion, fetchMessage, fetchGraph, selectTimeSpan } from '../actions';
import Header from '../components/Header';
import Status from '../components/Status';
import Map from '../components/Map/Map';
import Regions from '../components/Regions/Regions';
import Chart from '../components/Chart/Chart';
import globalStyles from '../styles';

const styles = {
  main: {
    padding: 15,
    display: 'block',
  },
  info: {
    fontSize: 13,
    marginTop: 0,
    marginBottom: 20,
    color: globalStyles.secondaryTextColor,
  },
};

class App extends Component {
  static propTypes = {
    regions: PropTypes.object.isRequired,
    selectedRegion: PropTypes.object,
    message: PropTypes.object,
    messageLoading: PropTypes.bool.isRequired,
    graphData: PropTypes.array.isRequired,
    graphLoading: PropTypes.bool.isRequired,
    timeSpan: PropTypes.string.isRequired,
    dispatch: PropTypes.func.isRequired,
    regionsNow: PropTypes.object.isRequired,
  };

  componentWillMount() {
    this.props.dispatch(fetchRegions());
    this.props.dispatch(fetchMessage());
    this.props.dispatch(fetchGraph());
  }

  handleRegionClick = (region) => {
    this.props.dispatch(selectRegion(region));
  };

  handleTimeSpanChange = (timeSpan) => {
    this.props.dispatch(selectTimeSpan(timeSpan));
  };

  render() {
    const {
      regions, selectedRegion, message, messageLoading, graphData, graphLoading, timeSpan,
      regionsNow,
    } = this.props;
    const incidents = regionsNow ?
      values(regionsNow).reduce((res, region) => res.concat(region.stations), []) : [];
    return (
      <div>
        <Header timeSpan={timeSpan} onTimeSpanChange={this.handleTimeSpanChange} />
        <main style={styles.main}>
          <Status
            message={message}
            loading={messageLoading}
            show={!incidents.length}
          />
          <div style={styles.info}>
            Karttapalvelu näyttää tiedot runkoverkon piirissä olevista häiriötilanteista ja
            suunnitelluista työkeskeytyksistä. Kartassa eivät näy pienjänniteverkon viat, jotka
            sijaitsevat jakelumuuntajan ja sähkönkäyttöpaikan välillä.
          </div>
          <Map
            regions={regions}
            selectedRegion={selectedRegion}
            timeSpan={timeSpan}
          />
          <Regions regions={regions} onRegionClick={this.handleRegionClick} />
          <Chart data={graphData} loading={graphLoading} selectedRegion={selectedRegion} />
        </main>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  regions: state.regions.regions,
  selectedRegion: state.regions.selected,
  message: state.messages.message,
  messageLoading: state.messages.loading,
  graphData: state.graph.data,
  graphLoading: state.graph.loading,
  timeSpan: state.map.timeSpan,
  regionsNow: state.regions.regionsNow,
});

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/containers/App.js